export default "__VITE_ASSET__BVbqVbiL__"